
export const PAGE_SIZE = 10;
/** 分页 */
export function Page(size, pagination) {
  this.pagination = pagination;
  this.size = size;
}

export const SYSTEM ={
  "SHOP": "门店端",
  "DISTRIBUTION": "配送中心端",
  "KITCHEN": "中央厨房端",
  "MERCHANT": "旗下商户端",
  "MANAGE": "集团管理端",
  "OPERATION": "运营维护端",
};
export const SYSTEM_VERIFY ={
  "SHOP": "SHOP",
  "DISTRIBUTION": "DISTRIBUTION",
  "KITCHEN": "KITCHEN",
  "MERCHANT": "MERCHANT",
  "MANAGE": "MANAGE",
  "OPERATION": "OPERATION",
};
export const SYSTEM_MODULE_LIST ={
  "SHOP": "门店",
  "DISTRIBUTION": "配送中心",
  "KITCHEN": "中央厨房",
  "MERCHANT": "商户",
};

export const WEBAPP_LIST ={
  "SHOP": process.env.VUE_APP_SHOP_WEBAPP_LOGIN_URL,
  "DISTRIBUTION": process.env.VUE_APP_DISTRIBUTION_WEBAPP_LOGIN_URL,
  "KITCHEN": process.env.VUE_APP_KITCHEN_WEBAPP_LOGIN_URL,
  "MERCHANT": process.env.VUE_APP_MERCHANT_WEBAPP_LOGIN_URL,
  "MANAGE": process.env.VUE_APP_MANAGE_WEBAPP_LOGIN_URL,
  "OPERATION": process.env.VUE_APP_OPERATION_WEBAPP_LOGIN_URL,
};

export const SHOP_STATUS ={
  "true": "停用",
  "false": "启用",
};

export const DISTRIBUTION_CENTER_STATUS ={
  "true": "停用",
  "false": "启用",
};

export const BOM_STATUS ={
  "true": "采用中",
  "false": "未采用",
};

export const KITCHEN_STATUS ={
  "true": "停用",
  "false": "启用",
};
export const MATERIAL_STATUS ={
  "true": "停用",
  "false": "启用",
};
export const MATERIAL_STATUS_QUERY ={
  2: "启用",
  1: "停用",
};
export const PRICE_MANAGE_STATUS ={
  1: "未生效",
  2: "已生效",
  3: "已作废",
};
export const SUPPLIER_STATUS_QUERY ={
  1: "已停用",
  2: "已启用",
};
export const SUPPLIER_STATUS ={
  "true": "停用",
  "false": "启用",
};
export const SUPPLIER_TYPE ={
  "INSTITUTION": "独立供应商",
  "PLATFORM": "平台供应商"
};

export const STAFF_STATUS_QUERY ={
  1: "注销",
  2: "启用",
};
export const STAFF_STATUS ={
  "true": "注销",
  "false": "启用",
};

export const SETTLE_TYPE ={
  "MONTH": "月结",
  "STEP": "次结",
};

export const SEX ={
  1: "男",
  2: "女",
};

export const input_verify = {
  TYPE_NUMERIC: 1,
  TYPE_LOWER_LETTER: 2,
  TYPE_UPPER_LETTER: 4,
  TYPE_UNDER_LINE: 16,
  TYPE_CHINESE_CHAR: 32,
  TYPE_CHINESE_PRINT_CHAR: 64,
  TYPE_SPECIAL_CHAR: 256
};
input_verify.TYPE_LETTER = input_verify.TYPE_LOWER_LETTER | input_verify.TYPE_UPPER_LETTER;
input_verify.TYPE_NONSPECIAL_CHAR = input_verify.TYPE_NUMERIC | input_verify.TYPE_LETTER |
  input_verify.TYPE_UNDER_LINE;




// WEBPACK FOOTER //
// ./src/assets/utils/constants.js